import axios, { AxiosError, AxiosResponse } from "axios";

const handleResponseSuccess = (response: AxiosResponse) => {
  return response.data;
};

const handleResponseError = (error: AxiosError) => {
  if (error.response) {
    // server responded with a non 2xx code - reject with a real Error so consumers
    // (react-query retry, CardBase's `error instanceof Error` guard) can read the
    // message and status. The original payload is preserved on `.data`.
    const message =
      typeof error.response.data === "string"
        ? error.response.data
        : error.message;
    const err = new Error(message) as Error & {
      status?: number;
      data?: unknown;
    };
    err.status = error.response.status;
    err.data = error.response.data;
    return Promise.reject(err);
  } else if (error.request) {
    // request was made but no response received
    return Promise.reject(error);
  } else {
    // something else happened before making the request
    return Promise.reject(error);
  }
};

const instance = axios.create();

instance.interceptors.response.use(handleResponseSuccess, handleResponseError);

export const setAuthHeader = (accessToken) => {
  instance.defaults.headers.common["Authorization"] = "Bearer " + accessToken;
};

export default instance;
